import en from "./en.json";
import fi from "./fi.json";

const TRANSLATIONS = {
	en
	, fi
};

export default TRANSLATIONS;
